import { RadarFusedTargetInfo } from '@ais-ui/websockets';
import React from 'react';
import { useSettings } from '../../Settings/SettingsProvider';
import { useDateTimeFormat } from '../../conversions/useDateFormat';
import {
  InfoTooltipFields,
  type TooltipFieldDefinition,
} from './InfoTooltipFields';

interface RadarFusedInfoTooltipProps {
  radarFusedInfo: RadarFusedTargetInfo;
}

export const RadarFusedInfoTooltip = ({
  radarFusedInfo,
}: RadarFusedInfoTooltipProps) => {
  const { settings } = useSettings();
  const { formatDateTimeWithTimeZone } = useDateTimeFormat();
  const ribbonSettings = settings['ribbonPlugin.settings'];

  const fields: TooltipFieldDefinition[] = [
    {
      key: 'mmsi',
      label: 'MMSI',
      value: radarFusedInfo.mmsi,
      visible: ribbonSettings?.show_radar_fused_mmsi,
    },
    {
      key: 'name',
      label: 'Name',
      value: radarFusedInfo.name,
      visible: ribbonSettings?.show_radar_fused_name,
    },
    {
      key: 'country',
      label: 'Country',
      value: radarFusedInfo.country,
      visible: ribbonSettings?.show_radar_fused_country,
    },
    {
      key: 'speed',
      label: 'SOG',
      value: radarFusedInfo.speed,
      visible: ribbonSettings?.show_radar_fused_speed,
    },
    {
      key: 'course',
      label: 'COG',
      value: radarFusedInfo.course,
      visible: ribbonSettings?.show_radar_fused_course,
    },
    {
      key: 'heading',
      label: 'Heading',
      value: radarFusedInfo.heading,
      visible: ribbonSettings?.show_radar_fused_heading,
    },
    {
      key: 'sensorSite',
      label: 'Sensor Site',
      value: radarFusedInfo.sensorSite,
      visible: ribbonSettings?.show_radar_fused_sensor_site,
    },
    {
      key: 'lastReport',
      label: 'Last Report',
      value: radarFusedInfo.lastReportTimestamp
        ? formatDateTimeWithTimeZone(radarFusedInfo.lastReportTimestamp)
        : undefined,
      visible: ribbonSettings?.show_radar_fused_last_report,
    },
    {
      key: 'latitude',
      label: 'Latitude',
      value: radarFusedInfo.latitude,
      visible: ribbonSettings?.show_radar_fused_latitude,
    },
    {
      key: 'longitude',
      label: 'Longitude',
      value: radarFusedInfo.longitude,
      visible: ribbonSettings?.show_radar_fused_longitude,
    },
  ];

  return <InfoTooltipFields fields={fields} />;
};
